/*!
* jQuery lightweight plugin boilerplate
* Original author: @ajpiano
* Further changes, comments: @addyosmani
* Licensed under the MIT license
*/
import $ from 'jquery';
import jQuery from 'jquery';
import { Core } from 'Util/core';
import { publish, unpublish, subscribe } from 'Util/pubsub';


; (function ($, window, document, undefined) {

	// Create the defaults once
	var pluginName = 'expandable',
		defaults = {
			selectorWrapper: '.js-expandable',
			selectorToggle: '.js-expandable__toggle',
			selectorContent: '.js-expandable__content',
			selectorFindAll: '.js-expand-all',

			expandedClass: 'is-expanded',
			disabledClass: 'is-disabled',
			allExpandedClass: 'all-expanded',

			animTime: 300,
			easing: 'ease'
		};

	// The actual plugin constructor
	function Expandable(element, options) {
		this.pluginName = pluginName;
		this.element = element;
		this.options = $.extend({}, defaults, options);

		this.$elements = $(element).filter(function () {
			return $(this).data('expandable/init') !== true;
		});

		this.$expand = $(this.options.selectorFindAll);
		this.init();
		this.$elements.data('expandable/init', true);
	}

	Expandable.prototype.init = function () {
		this.bindEvents();
	};

	Expandable.prototype.bindEvents = function () {
		this.$expand.on('click', this.controlAll.bind(this));
		this.$elements.on('click', this.options.selectorToggle, this.toggle.bind(this));
		this.$elements.on('expandable/toggle', this.toggle.bind(this));
		this.$elements.on('expandable/open', this.open.bind(this));
		this.$elements.on('expandable/close', this.close.bind(this));
	};

	Expandable.prototype.unbindEvents = function () {
		this.$expand.off('click', this.controlAll.bind(this));
		this.$elements.off('click', this.options.selectorToggle, this.toggle.bind(this));
		this.$elements.off('expandable/toggle', this.toggle.bind(this));
		this.$elements.off('expandable/open', this.open.bind(this));
		this.$elements.off('expandable/close', this.close.bind(this));
	};

	Expandable.prototype.initElements = function () {
		// This enforces the appropriate inline styles are applied,
		// so the initial animation can work correctly

		var Expandable = this;

		this.$elements.each(function () {
			var $el = $(this);

			if ($el.hasClass(Expandable.options.expandedClass)) {
				$el.trigger('expandable/open');
			} else {
				$el.trigger('expandable/close');
			}
		});
	};

	Expandable.prototype.controlAll = function (e) {
		var $this = $(e.target).closest('.js-expand-all');
		if ($this.hasClass(this.options.allExpandedClass)) {
			this.$elements.trigger('expandable/close');
			$this.removeClass(this.options.allExpandedClass);
		} else {
			this.$elements.trigger('expandable/open');
			$this.addClass(this.options.allExpandedClass);
		}
	};

	Expandable.prototype.toggle = function (e) {
		var $wrapper = $(e.target).closest(this.options.selectorWrapper);

		if ($wrapper.hasClass(this.options.disabledClass)) {
			return false;
		}

		if ($wrapper.hasClass(this.options.expandedClass)) {
			$wrapper.trigger('expandable/close');
		} else {
			$wrapper.trigger('expandable/open');
		}
	};

	Expandable.prototype.open = function (e, $el) {
		var $content;

		$el = $el || $(e.target);
		$content = $el.find(this.options.selectorContent);
		$el.addClass(this.options.expandedClass);
	};

	Expandable.prototype.close = function (e, $el) {
		var $content,
			$wrapper;

		$el = $el || $(e.target);
		$content = $el.find(this.options.selectorContent);
		$wrapper = $content.closest(this.options.selectorWrapper);
		$el.removeClass(this.options.expandedClass);

		if ($wrapper.data('expandable/init')) {
			// Don't do this if it's the initialisation "close" event
			if ($wrapper.data('scroll-on-collapse')) {
				Core._scrollToElmSmart($wrapper);
			}
		}

		publish('tooltip/closeAll', {
			container: $el
		});
	};

	Expandable.prototype.destroy = function () {
		this.$elements.each(this.unbindEvents.bind(this));
	};

	/* Create the plugin */
	$.fn[pluginName] = function (options) {

		var plugin;

		if (options === 'destroy') {
			plugin = $(this).data('plugin_' + pluginName);
			if (!plugin) {
				return;
			}
			plugin.destroy();
			return;
		}

		if (!$.data(this, 'plugin_' + pluginName)) {
			plugin = new Expandable(this, options);
			$(this).data('plugin_' + pluginName, plugin);
		}

		return plugin;
	};

})(jQuery, window, document);